import { reverseTransformPoint } from "@/canv/utils";
import { clamp } from "@/shared/lib/clamp";

type Coordinates = {
    top: number;
    left: number;
};

export function calculateInputCoordinates(
    coordinates: Coordinates,
    wrapperRect: DOMRect,
    canvasRect: DOMRect,
) {
    const point = reverseTransformPoint(coordinates.left, coordinates.top);

    const horizontalPadding = 10;
    const minTop = 60;
    const gap = 50;

    const left = clamp(
        point.x - wrapperRect.width / 2,
        horizontalPadding,
        canvasRect.width - wrapperRect.width - horizontalPadding,
    );

    const top = clamp(
        point.y - wrapperRect.height - gap,
        minTop,
        canvasRect.height - wrapperRect.height - horizontalPadding,
    );

    return { top, left };
}
